require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./works-2019-04-29-support-system.json") })
        }
      }, "path---works-2019-04-29-support-system");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---works-2019-04-29-support-system!./.cache/json/works-2019-04-29-support-system.json
// module id = 433
// module chunks = 231608221292675